import { HeaderSeverityBadgeVariant } from '@ui/drawer/common/HeaderSeverityBadge'
import { TStatus } from '@/ui/components/cases-table/CasesTable.utils'

export const getCaseSeverityVariant = (
    severity?: string
): HeaderSeverityBadgeVariant | undefined => {
    switch (severity?.toLowerCase()) {
        case 'critical':
            return 'critical'
        case 'high':
            return 'important'
        case 'medium':
            return 'moderate'
        case 'low':
            return 'low'
        case 'informational':
        case 'info':
            return 'info'
        default:
            return undefined
    }
}

const VALID_STATUSES = new Set<TStatus>([
    'waiting',
    'inprogress',
    'closed',
    'open',
])

export const getCaseStatus = (status?: string): TStatus | undefined => {
    const normalized = status?.toLowerCase() as TStatus
    return VALID_STATUSES.has(normalized) ? normalized : undefined
}
